var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
require("!!style-loader!css-loader!vue-loader/lib/style-rewriter?id=data-v-253ed8b6!postcss-loader!sass-loader?sourceMap!import-glob-loader!vue-loader/lib/selector?type=styles&index=0!./swiper.amd.vue")

/* script */
__vue_exports__ = require("!!babel-loader?presets[]=es2015&babelrc=false!import-glob-loader!component-example-dir-loader!vue-loader/lib/selector?type=script&index=0!./swiper.amd.vue")
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

if(typeof __vue_options__.name === "undefined") {
  __vue_options__.name = "swiper.amd"
}
module.exports = __vue_exports__



//////////////////
// WEBPACK FOOTER
// ./app/components/organisms/swiper/swiper.amd.vue
// module id = 285
// module chunks = 1